export default "__VITE_ASSET__1752b42f__"